import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import type { IssueCategoriesVersion } from '../online-eval.types';

export const CategoryVersionHistory = ({
  versions,
}: {
  versions: IssueCategoriesVersion[];
}) => (
  <Card>
    <CardHeader className="pb-2">
      <CardTitle className="text-base">Version history</CardTitle>
      <CardDescription>
        Every change saves a new version of the categories. Each finding records
        the version it was evaluated with, so findings from different versions
        can be told apart.
      </CardDescription>
    </CardHeader>
    <CardContent>
      {versions.length === 0 ? (
        <p className="text-sm text-muted-foreground">No versions yet.</p>
      ) : (
        <ol className="space-y-3">
          {versions.map((version) => (
            <li key={version.id} className="text-sm">
              <div className="font-medium">
                Version {version.id}
                <span className="ml-2 text-xs font-normal text-muted-foreground">
                  {new Date(version.created_at).toLocaleString()}
                </span>
              </div>
              <ul className="mt-1 list-disc pl-5 text-muted-foreground">
                {version.changes.length === 0 ? (
                  <li>No changes</li>
                ) : (
                  version.changes.map((change) => (
                    <li key={change}>{change}</li>
                  ))
                )}
              </ul>
            </li>
          ))}
        </ol>
      )}
    </CardContent>
  </Card>
);
